import { render, staticRenderFns } from "./MakeSmallTextCell.vue?vue&type=template&id=797be206"
import script from "./MakeSmallTextCell.vue?vue&type=script&lang=js"
export * from "./MakeSmallTextCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports